import 'twin.macro';
import React from 'react';

interface Props {
  title?: string;
  className?: string;
}

export function Separator(props: Props) {
  const { title } = props;
  return (
    <div tw="relative mb-6" className={props.className}>
      <div tw="absolute -inset-6 flex items-center" aria-hidden="true">
        <div tw="w-full border-t border-neutral-quiet" />
      </div>
      <div tw="relative flex justify-center">
        <span tw="px-2 bg-white text-neutral-intense text-3xl tracking-tight">
          {title}
        </span>
      </div>
    </div>
  );
}
